import { formatArrayToElSelect } from "./../../utils";
import api from "../../api";

const state = {
  status: "",
  list: []
};

const getters = {
  list_to_select: (state) => formatArrayToElSelect(state.list)
};

const actions = {
  getDealOfType: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/DealOfType/All")
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  removeItem: (state, id) => {
    const index = state.list.findIndex((item) => item.Id === id);
    state.list.splice(index, 1);
  },
  pushItem: (state, item) => {
    state.list.push(item);
  },
  updateItem: (state, payload) => {
    const index = state.list.findIndex((l) => l.Id === payload.Id);
    state.list.splice(index, 1, payload.item);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
